import { useEffect, useState } from "react";
import { useLabels, useMapCore } from "../hooks";
import { Button } from "../primitives/Button";

export type FullscreenButtonProps = { className?: string };

function rootOf(element: HTMLElement): HTMLElement {
  return element.closest<HTMLElement>(".fxmap") ?? element;
}

export function FullscreenButton({ className }: FullscreenButtonProps) {
  const core = useMapCore();
  const labels = useLabels();
  const supported = typeof document !== "undefined" && typeof document.documentElement.requestFullscreen === "function" && document.fullscreenEnabled !== false;
  const [active, setActive] = useState(() => (typeof document === "undefined" ? false : document.fullscreenElement !== null && document.fullscreenElement === rootOf(core.container)));

  useEffect(() => {
    const onChange = () => {
      setActive(document.fullscreenElement !== null && document.fullscreenElement === rootOf(core.container));
      setTimeout(() => core.view.invalidateSize(), 0);
    };

    document.addEventListener("fullscreenchange", onChange);

    return () => document.removeEventListener("fullscreenchange", onChange);
  }, [core]);

  return <Button kind="icon" size="lg" icon={active ? "exitFullscreen" : "fullscreen"} label={active ? labels.exitFullscreen : labels.fullscreen} className={["fxmap-fullscreen-button", className ?? ""].filter(Boolean).join(" ")} data-fxmap="fullscreen" pressed={active} disabled={!supported} onClick={() => core.view.toggleFullscreen()} />;
}
